import { Describe, is, string, type } from 'superstruct';

export const LanguageValidator: Describe<LanguageDto> = type({
  langcode: string(),
  name: string(),
  prefix: string(),
});
export const isAppLanguage = (obj: unknown) => is(obj, LanguageValidator);
